import { Button, type ButtonProps } from '@/components/base/button'
import { Icon, type IconTagName } from '@/components/common/icons/Icon'
import { cn } from '@/helpers/utils'

interface ButtonParticipantProps extends ButtonProps {
  isActive?: boolean
  isVisible?: boolean
  tag: IconTagName
}

export const ButtonParticipant = ({
  children,
  isActive = true,
  isVisible = true,
  onClick,
  tag,
  ...props
}: ButtonParticipantProps) => {
  if (!isVisible) {
    return null
  }

  return (
    <Button
      className={cn('px-1', !isActive && 'text-destructive')}
      onClick={onClick}
      variant="icon"
      {...props}
    >
      <Icon tag={tag} size="xl" />
      {children}
    </Button>
  )
}
